import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Heading as HeadingComponent } from './Heading';
export const Heading = withComponentMeta(HeadingComponent, createBuiltInComponentMeta('Heading'));
//# sourceMappingURL=index.js.map